<template>
    <auth-layout>
        <Head>
            <title>Registrieren</title>
        </Head>
        <div class="auth-form">
            <div class="auth-form--form">
                <h3 v-translate>Wertarbeit für <br/>Geschäftskunden.</h3>
                <form @submit.prevent="submit">
                    <div class="error" v-if="form.errors.email === 'validation.unique'">Email vergeben, zum Login?</div>

                    <form-input type="email" id="email" :label="this.$gettext('Email Adresse')" v-model="form.email" :placeholder="this.$gettext('john@doe.com')" :error="form.errors.email" icon="email-mail-checkmark" autocomplete="email" autofocus />

                    <div class="form-actions">
                        <Link :href="$route('client.login')"><translate>Sie haben bereits einen Account?</translate></Link>
                        <form-button type="submit" color="secondary" icon="button-arrow-right-circle" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>weiter</translate></form-button>
                    </div>
                </form>
            </div>
            <div class="auth-form--info">
                <p class="body-2 body-2--disabled">
                    <translate>Es können ausschließlich <strong>registrierte Geschäftskunden</strong> beliefert werden.
                        An Privatpersonen liefern wir nicht aus! Ihre Daten werden nur für Ihre Anfragen und Aufträge
                        genutzt, nicht an Dritte weitergeleitet, nicht für Werbezwecke verwendet. Das garantieren wir Ihnen.
                        Ihre Kundendaten handhaben wir streng vertraulich, gemäß den Datenschutzbestimmungen der
                        Bundesrepublik Deutschland.
                    </translate>
                </p>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@partfactory/Layouts/AuthLayout';
import FormInput from '@partfactory/Shared/Form/FormInput';
import {useForm} from '@inertiajs/vue3';
import FormButton from '@partfactory/Shared/Form/FormButton';

export default {
    name: 'Register',
    components: {
        FormButton,
        FormInput,
        AuthLayout,
    },
    setup() {
        const form = useForm({
            email: null
        });

        return {form};
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$route('client.register.account'), {
                    onSuccess: () => {
                        // Registrierung-Formular abgeschickt (Schritt 1)
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            'event': 'form_send',
                            'formName': 'Registrierung',
                            'formStep': '1 - Registrierung Email',
                            'formLang': this.$language.current,
                        });
                    }
                });
        },
    }
};
</script>
